import { render, staticRenderFns } from "./Warranty-Detail.vue?vue&type=template&id=5b5a402c"
import script from "./Warranty-Detail.vue?vue&type=script&lang=js"
export * from "./Warranty-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports